import * as types from './types';

const INITIAL_STATE = {
  data: null,
  fetchError: null,
  submitError: null,
  submitting: false,
  submitted: false,
  fetching: false,

  //Mobile Inventory License Count
  fetchingMobileInventoryLicense: false,
  mobileInventoryLicenseData: 0,
  fetchMobileInventoryLicenseError: null,

  fetchingMobileSync: false,
  mobileSyncResponseMsg: '',
  fetchMobileSyncError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CONTROL_INFO_FETCHING:
      return {
        ...state,
        fetching: action.payload,
      };

    case types.CONTROL_INFO_SUBMITTING:
      return {
        ...state,
        submitting: action.payload,
      };

    case types.CONTROL_INFO_SUBMIT_SUCCESS:
      return {
        ...state,
        submitted: true,
      };

    case types.CONTROL_INFO_GET_DISTRICT_INFO:
      return {
        ...state,
        data: action.payload,
      };

    case types.CONTROL_INFO_FETCH_ERROR:
      return {
        ...state,
        fetchError: action.payload,
      };

    case types.CONTROL_INFO_SUBMIT_ERROR:
      return {
        ...state,
        submitError: action.payload,
      };

    case types.CONTROL_INFO_CLEAR_ERROR_SUCCESS:
      return {
        ...state,
        fetchError: null,
        submitError: null,
        submitted: false,
        mobileSyncResponseMsg: '',
      };

    //mobile inventory license
    case types.MOBILE_INVENTORY_LICENSE_COUNT_FETCHING:
      return {
        ...state,
        fetchingMobileInventoryLicense: action.payload,
      };

    case types.MOBILE_INVENTORY_LICENSE_COUNT_DATA:
      return {
        ...state,
        mobileInventoryLicenseData: action.payload,
      };

    case types.MOBILE_INVENTORY_LICENSE_COUNT_FETCH_ERROR:
      return {
        ...state,
        fetchMobileInventoryLicenseError: action.payload,
      };

    case types.MOBILE_SYNC_INFO_FETCHING:
      return {
        ...state,
        fetchingMobileSync: action.payload,
      };

    case types.MOBILE_SYNC_INFO_DATA:
      return {
        ...state,
        mobileSyncResponseMsg: action.payload,
      };

    case types.MOBILE_SYNC_INFO_FETCH_ERROR:
      return {
        ...state,
        fetchMobileSyncError: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/districtInfo/reducer.js